module.exports = __webpack_public_path__ + "static/7-55ac19d7adb62b222986c20242afcad7.jpg";